<template>
  <div class="content content-full">
    <div class="page-navs bg-white">
      <div class="nav-scroller">
        <div
          class="nav nav-tabs nav-line nav-color-secondary d-flex align-items-center justify-contents-center w-100"
        >
          <span class="nav-link" href="javascript:void(0)">
            Mastering <span class="badge-pro badge-primary fw-bold px-2 py-1">PRO</span>
          </span>
          <div class="ml-auto">
            <button type="button" @click="newMaster()" class="btn btn-gradient">{{ $t('new_mastering') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="page-inner">
      <!-- <div class="text-center mb-2 mt-2" v-if="!user.subscription">
        <ins class="adsbygoogle"
            style="display:block"
            data-ad-client="ca-pub-8326584585992829"
            data-ad-slot="8454890613"
            data-ad-format="auto"
            data-full-width-responsive="true"></ins>
      </div> -->
      <div class="p-5 text-center" v-if="loading">
        <i class="fas fa-spinner fa-spin text-muted"></i>
      </div>
      <div class="card" v-if="!loading && !masterings.length">
        <img src="/static/img/services/mastering-banner.png" alt="" width="100%">
        <div class="card-body mastering-description">
          <div class="fw-700">
            {{ $t('mastering_title_description')}}
          </div>
          <div class="text-center">
            <hr>
          </div>
          <div class="mt-3 fw-200">
            {{ $t('mastering_description_2')}}
          </div>
          <div class="mt-3 fw-200">
            {{ $t('mastering_description_3') }}
          </div>
          <div class="mt-4 text-center mb-3">
            <button type="button" @click="newMaster()" class="btn btn-gradient btn-lg">{{ $t('start_now') }}</button>
          </div>
        </div>
      </div>
      <div class="card" v-if="!loading && masterings.length">
        <div class="table-responsive">
          <table class="table mb-0">
            <thead>
              <tr>
                <th>Master</th>
                <th>{{ $t('status') }}</th>
                <th>{{ $t('created') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in masterings" v-bind:key="item._id">
                <td>
                  <router-link :to="`/tools/mastering/${item._id}`">
                    {{ item.name || item._id }}
                  </router-link>
                </td>
                <td>
                  <span v-if="!item.job_status && !item.master_job_status">
                    {{ $t('not_started') }}
                  </span>
                  <span v-if="item.job_status && !item.master_job_status" class="text-primary">
                    {{ $t('previews_generated')}}
                  </span>
                  <span v-if="item.job_status && item.master_job_status" class="text-success">
                    {{ $t('mastering_finished') }}
                  </span>
                </td>
                <td>
                  {{ moment(item.createdAt).format('LL') }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Mastering from '../services/mastering'

export default {
  name: 'MainMastering',
  data () {
    return {
      stripe: window.Stripe('pk_live_Fy0LR9SOyRoSrq4Byoj3mQtS00GjNUCMRm'),
      loading: true,
      user: {},
      masterings: [],
      moment
    }
  },
  methods: {
    redirectToCheckout: function () {
      let priceId = 'price_1LOUjTK9qKRAJ5zqMwKFGV1E' // Basic

      if (this.user.subscription) {
        priceId = 'price_1NQXw1K9qKRAJ5zqCc2OOeZL' // PRO
      }

      if (this.user.role === 'admin') {
        priceId = 'price_1NQaLBK9qKRAJ5zqK9eBtbgv'
      }

      this.stripe.redirectToCheckout({
        lineItems: [{ price: priceId, quantity: 1 }],
        mode: 'payment',
        customerEmail: this.user.email,
        successUrl: 'https://indiefy.net/v1/api/mastering-checkout',
        cancelUrl: 'https://' + location.hostname + '/tools/mastering?cancelled=1'
      }).then(function (result) {
        if (result.error) {
          alert(result.error.message)
        }
      })
    },
    newMaster: function () {
      if (this.user.subscription) {
        return this.redirectToCheckout()
      }

      this.$eventBus.$emit('showPriceComparison', {
        productTitle: 'Mastering',
        basicCost: '15.00',
        proCost: '5.99',
        basicCallback: () => {
          this.redirectToCheckout()
        },
        proCallback: () => {
          this.$router.push('/upgrade?from=mastering')
        }
      })
    },
    getMasterings: function () {
      Mastering.getAll()
        .then(response => {
          this.masterings = response.data
          this.loading = false
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  created: function () {
    this.user = this.$user
    this.getMasterings()

    if (this.$route.query.success_checkout) {
      this.$notify({ message: this.$t('purchase_success') }, 'success', 'fa-check')

      setTimeout(() => {
        this.getMasterings()
      }, 1000 * 5)
    }
  },
  mounted: function () {
    setTimeout(() => {
      if (!this.user.subscription) {
        (window.adsbygoogle = window.adsbygoogle || []).push({})
      }
    }, 1000)
  }
}
</script>

<style scoped>
.pricing-title {
  border: 2px solid white;
  display: inline-block;
  padding: 3px 10px;
  border-radius: 3px;
}

.basic-price {
  font-size: 25px;
}
.pro-price {
  font-size: 45px;
}

.mastering-description {
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/MasteringMain.vue